export const colorIndexesDevelopTimeLine = {
  green: [12, 7, 16],
  blue: [5, 0, 6],
  red: [5, 0, 6],
  blueGreen: [5, 0, 8],
  blueRed: [1, 35, 18],
  blueYellow: [5, 3, 6],
};
